<template>
  <b-overlay
    :show="loader.form"
    rounded="sm"
  >
    <b-tabs
      fill
      pills
    >
      <!-- Datos de plan de estudios -->
      <b-tab active>
        <template #title>
          <feather-icon icon="MonitorIcon" />
          <span>Principal</span>
        </template>

        <!-- Datos básicos de un plan de estudios -->
        <validation-observer ref="formPlan">
          <b-card class="blog-edit-wrapper">
            <titleSection
              v-if="!isEmptyObject(planEstudios)"
              :title="(planEstudios.nombre) ? planEstudios.nombre : 'Ingrese nombre del plan de estudios'"
              :subtitle="(planEstudios.activo) ? 'Activo' : 'Inactivo'"
              icon="MonitorIcon"
            />
            <!-- Información de plan de estudios -->
            <b-form
              v-if="!isEmptyObject(planEstudios)"
              class="mt-2"
            >
              <b-row>
                <!-- Especialidad -->
                <b-col
                  md="12"
                >
                  <p
                    class="my-0"
                  > * No olvide <strong>asignar la o las materias</strong> (pestaña de la derecha) para que pueda dar de alta cursos.</p>
                  <p
                    v-if="id || userRole.id !== 12"
                    class="my-0"
                  >
                    * Si no encuentra la especialidad solicite al área de TICs que se agrege a la tabla especialidad en base de datos.
                  </p>
                  <div
                    v-if="!id && userRole.id === 12"
                    class="my-0"
                  >
                    <hr>
                    <p class="text-center">
                      <strong>Instrucciones solo para dar de alta nuevos planes tipo curso</strong>
                    </p>
                    <p>
                      * Por favor busque la especialidad que corresponde al plan de estudios tipo curso que desea dar de alta;
                      si no la encuentra seleccione la división y coloque la abreviación del nombre del curso.
                    </p>
                    <p>
                      * En caso que no encuentre la división contacte al equipo de sistemas TICs, si urge dar de alta el curso puede seleccionar cualquier división y posteriormente ponerse en contacto con el equipo TIC's
                    </p>

                  </div>
                </b-col>

                <!-- Especialidad -->
                <b-col
                  v-if="!nuevaespecialidad"
                  md="9"
                >
                  <b-form-group
                    label="Especialidad *"
                    label-for="plan-especialidad"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="especialidad"
                      rules="required"
                    >
                      <v-select
                        id="plan-especialidad"
                        v-model="planEstudios.especialidad"
                        placeholder="Sin especialidad"
                        label="nombre_corto"
                        :class="{ 'form-control is-invalid p-0' : (errors.length > 0 ? false:null) == false }"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="especialidades"
                        :clearable="false"
                      >
                        <template #no-options>
                          <em style="opacity: 0.5;">No hay resultados para mostar</em>
                        </template>
                      </v-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!--Division -->
                <b-col
                  v-if="!id && userRole.id === 12 && nuevaespecialidad"
                  md="6"
                >
                  <b-form-group
                    label="Division *"
                    label-for="division"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="division"
                      rules="required"
                    >
                      <v-select
                        id="division"
                        v-model="planEstudios.division"
                        placeholder="Sin división"
                        label="nombre"
                        :class="{ 'form-control is-invalid p-0' : (errors.length > 0 ? false:null) == false }"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="divisiones"
                        :clearable="false"
                      >
                        <template #no-options>
                          <em style="opacity: 0.5;">No hay resultados para mostar</em>
                        </template>
                      </v-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- nombre corto -->
                <b-col
                  v-if="!id && userRole.id === 12 && nuevaespecialidad"
                  md="3"
                >
                  <b-form-group
                    label="Abreviación especialidad"
                    label-for="nombre_corto"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="abreviación"
                      rules="required|max:25"
                    >
                      <b-form-input
                        id="email_cont"
                        v-model="planEstudios.nombre_corto"
                        placeholder="Ej: C-CRCVM"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!--no encuentro la especialidad-->
                <b-col
                  v-if="!id && userRole.id === 12"
                  md="3"
                >
                  <div class="text-nowrap text-center">
                    <b-form-group
                      label="No encuentro la especialidad"
                      label-for="nueva-especialidad"
                      class="mb-2"
                    >
                      <b-form-checkbox
                        v-model="nuevaespecialidad"
                        name="check-button"
                        class="mt-25"
                        switch
                        inline
                        :value="1"
                        :unchecked-value="0"
                      />
                    </b-form-group>
                  </div>
                </b-col>

                <!-- aamm -->
                <b-col md="3">
                  <b-form-group
                    label="Año Mes de inicio y número *"
                    label-for="plan-aamm"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="aamm"
                      rules="required|positive|max:6"
                    >
                      <b-form-input
                        id="plan-aamm"
                        v-model="planEstudios.aamm"
                        placeholder="aammN°"
                        type="number"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Nombre -->
                <b-col md="7">
                  <b-form-group
                    label="Nombre del plan de estudios *"
                    label-for="plan-nombre"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="nombre"
                      rules="required"
                    >
                      <b-form-input
                        id="plan-nombre"
                        v-model="planEstudios.nombre"
                        placeholder="Nombre"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Estatus -->
                <b-col md="2">
                  <div class="text-nowrap text-center">
                    <b-form-group
                      label="Disponibilidad"
                      label-for="plan-activo"
                      class="mb-2"
                    >
                      <b-form-checkbox
                        v-model="planEstudios.activo"
                        name="check-button"
                        class="mt-25"
                        switch
                        inline
                        :value="1"
                        :unchecked-value="0"
                      >
                        {{ planEstudios.activo ? 'Activo' : 'Inactivo' }}
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                </b-col>

                <b-col
                  md="12"
                  class="mb-2"
                >
                  <strong class="text-warning">Si no cuentas con los datos *producto y *clave, por favor no vaya a crear el plan de estudios hasta tenerlos.</strong> <strong>Verifica el producto y la clave de área sean correctos, ya que no se podrán editar después de guardar, estos datos se utilizan para generar: referencias bancarias, pagos en línea y facturación. Por favor, asegúrate de que esten bien escritos.</strong>
                </b-col>

                <!-- Producto -->
                <b-col md="6">
                  <b-form-group
                    label="Producto *"
                    label-for="producto"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="producto"
                      rules="required|length:3"
                    >
                      <b-form-input
                        id="producto"
                        v-model="planEstudios.configuracion.producto"
                        placeholder="Producto"
                        :state="errors.length > 0 ? false:null"
                        :disabled="planEstudios.id ? true : false"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- clave-->
                <b-col md="6">
                  <b-form-group
                    label="Clave de área *"
                    label-for="clave de area"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="clave de área"
                      rules="required|length:2"
                    >
                      <b-form-input
                        id="clave"
                        v-model="planEstudios.configuracion.clave"
                        placeholder="Clave de área"
                        :state="errors.length > 0 ? false:null"
                        :disabled="planEstudios.id ? true : false"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  class="mb-2"
                >
                  Número de identificación (Facturación) <strong>{{ planEstudios.configuracion.codigo_servicio || 'Sin asignar' }}</strong>

                </b-col>

                <!-- Descripción -->
                <b-col cols="12">
                  <b-form-group
                    label="Descripción"
                    label-for="plan-descripcion"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="descripcion"
                    >
                      <b-form-textarea
                        id="plan-descripcion"
                        v-model="planEstudios.descripcion"
                        placeholder="Descripcion del plan de estudios"
                        :state="errors.length > 0 ? false:null"
                        rows="3"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Objetivo -->
                <b-col cols="12">
                  <b-form-group
                    label="Objetivo"
                    label-for="plan-objetivo"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="objetivo"
                    >
                      <b-form-textarea
                        id="plan-objetivo"
                        v-model="planEstudios.objetivo"
                        placeholder="Objetivo del plan de estudios"
                        :state="errors.length > 0 ? false:null"
                        rows="3"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Perfil ingreso -->
                <b-col cols="12">
                  <b-form-group
                    label="Perfil de ingreso (opcional)"
                    label-for="plan-perfil-ingreso"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="perfil ingreso"
                    >
                      <b-form-textarea
                        id="plan-perfil-ingreso"
                        v-model="planEstudios.perfil_ingreso"
                        placeholder="Perfil de ingreso"
                        :state="errors.length > 0 ? false:null"
                        rows="3"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Perfil egreso -->
                <b-col cols="12">
                  <b-form-group
                    label="Perfil de egreso (opcional)"
                    label-for="plan-perfil-egreso"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="perfil egreso"
                    >
                      <b-form-textarea
                        id="plan-perfil-egreso"
                        v-model="planEstudios.perfil_egreso"
                        placeholder="Perfil de egreso"
                        :state="errors.length > 0 ? false:null"
                        rows="3"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Perfil egreso -->
                <b-col cols="12">
                  <b-form-group
                    label="Contenido extra acerca de (opcional)"
                    label-for="plan-contenido-extra"
                    class="mb-2"
                  >
                    <b-form-textarea
                      id="plan-contenido-extra"
                      v-model="planEstudios.contenido_extra"
                      :placeholder="`Escribir html ejemplo:
                      <div class='boton-wrapper'>
                      <a href='#' class='boton-indicio'>
                        <span class='icono'>❓</span>
                        ¿Por qué visitar Guadalajara?</a>
                      </div>
                      <style>
                      </style>
                      `

                      "
                      rows="8"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <hr>
                  <p><strong>Datos de contacto</strong>: esta información aparece en el detalle del plan de estudios en la zona pública. (Opcional, si se desea capturar el contacto, deberá de llenar todos estos campos)</p>
                </b-col>

                <!-- email_cont -->
                <b-col md="6">
                  <b-form-group
                    label="Correo de contacto"
                    label-for="email_cont"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="email_cont"
                      rules="max:255"
                    >
                      <b-form-input
                        id="email_cont"
                        v-model="planEstudios.contacto.email_cont"
                        placeholder="Correo de contacto"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- horario_cont -->
                <b-col md="6">
                  <b-form-group
                    label="Horario de contacto"
                    label-for="horario_cont"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="horario_cont"
                      rules="max:255"
                    >
                      <b-form-input
                        id="horario_cont"
                        v-model="planEstudios.contacto.horario_cont"
                        placeholder="Sugerencia: Lunes a Viernes 8:00am a 3:00pm"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- telefono_cont -->
                <b-col md="6">
                  <b-form-group
                    label="Teléfono de contacto"
                    label-for="telefono_cont"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="telefono_cont"
                      rules="max:255"
                    >
                      <b-form-input
                        id="telefono_cont"
                        v-model="planEstudios.contacto.telefono_cont"
                        placeholder="Sugerencia: 33 3669 5550 al 59"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- extension_cont -->
                <b-col md="6">
                  <b-form-group
                    label="Extensión de contacto"
                    label-for="extension_cont"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="extension_cont"
                      rules="max:255"
                    >
                      <b-form-input
                        id="extension_cont"
                        v-model="planEstudios.contacto.extension_cont"
                        placeholder="Extensión de contacto"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

              </b-row>
            </b-form>

            <!-- Botones de cancelación y guardado -->
            <div class="text-right">
              <!-- Save changes -->
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-1"
                @click.prevent="validationForm"
              >
                Guardar cambios
              </b-button>
              <!-- Cancel -->
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="outline-danger"
                @click="(id) ? $emit('update:id', null) : $router.push('/servicio-escolar/dashboard')"
              >
                Cancelar
              </b-button>
            </div>
          </b-card>
        </validation-observer>
      </b-tab>

      <!-- Materias asignadas -->
      <b-tab lazy>
        <template #title>
          <feather-icon icon="ClipboardIcon" />
          <span>Materias</span>
        </template>
        <b-card>
          <titleSection
            title="Materias asignadas"
            subtitle="Listado de materias que serán impartidas"
            icon="ClipboardIcon"
            class="mb-2"
          />

          <edit-materia-plan
            :plan-estudios="id"
            :temporalidad-prop="planEstudios.temporalidad"
            @set-loader="loader.form = $event"
            @reload-data="loadPlanData"
          />
        </b-card>
      </b-tab>
    </b-tabs>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BOverlay,
  BFormCheckbox,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BTabs,
  BTab,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import titleSection from '@/views/components/title-section.vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  ref, onMounted, computed, watch,
} from '@vue/composition-api'
import store from '@/store'
import vSelect from 'vue-select'
import { isEmptyObject } from '@core/utils/utils'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import editMateriaPlan from './EditMateriasPlan.vue'
import { planInfo, especialidadesList, divisionesList } from '../usePlanes'

export default {
  components: {
    BCard,
    BOverlay,
    BFormCheckbox,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    vSelect,
    BTabs,
    BTab,
    titleSection,
    editMateriaPlan,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  setup(props, { emit }) {
    const toast = useToast()
    const planEstudios = ref({})
    const loader = ref({ form: false })
    const seriacionSelected = ref(null)
    const especialidades = ref([])
    const divisiones = ref([])
    const formPlan = ref(null)
    const nuevaespecialidad = ref(false)
    const userRole = computed(() => store.state.cuenta.rolSelected)
    //* Computed method to get form values
    const getValuesToSend = computed(() => {
      const {
        especialidad, nuevaesp, nombre, descripcion, aamm, activo, objetivo, perfil_ingreso, perfil_egreso, configuracion, contacto, division, nombre_corto, contenido_extra,
      } = planEstudios.value

      return {
        especialidad, nuevaesp, nombre, descripcion, aamm, activo, objetivo, perfil_ingreso, perfil_egreso, configuracion, contacto, division, nombre_corto, contenido_extra,
      }
    })

    //* Set plan Estudios data as an empty object
    const newPlanData = () => {
      planEstudios.value = {
        especialidad: {
          id: null,
          division: null,
          nivel: null,
          nombre_corto: null,
        },
        nombre: null,
        descripcion: null,
        aamm: null,
        activo: 0,
        objetivo: null,
        perfil_ingreso: null,
        perfil_egreso: null,
        contenido_extra: null,
        nombre_especialidad: null,
        nivel: null,
        temporalidad: [],
        configuracion: {
          producto: null,
          clave: null,
        },
        contacto: {
          id_cont: null,
          email_cont: null,
          telefono_cont: null,
          extension_cont: null,
          horario_cont: null,
        },
        nombre_corto: null,
        division: {
          id: null,
          nombre: null,
        },
      }
    }

    //* Save changes
    const saveChanges = () => {
      const toUpdate = getValuesToSend.value
      loader.value.form = true
      const data = {
        task: 'wsplanEstudios',
        action: props.id ? 4 : 3, //* Si hay id es edición [4], sino nuevo item [3]
        datos: JSON.stringify(toUpdate),
        r: userRole.value.id,
      }

      if (props.id !== undefined && props.id) data.plan_estudios = props.id //* Si existe id, envío plan_estudios [Es edición]

      store.dispatch('servicioEscolar/postServicioEscolar', data)
        .then(response => {
          loader.value.form = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Solicitud exitosa',
              text: response.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          },
          { timeout: 8000 })
          if (!props.id) {
            newPlanData()
            emit('refetch-data')
          }
        }, error => {
          loader.value.form = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    //* Load plan data
    const loadPlanData = () => {
      loader.value.form = true
      planInfo(props.id).then(response => {
        loader.value.form = false
        planEstudios.value = response
      }, error => {
        loader.value.form = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Información de materia]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
    }

    //* Carga catálogo de especialidades
    const loadEspecialidades = () => {
      especialidadesList().then(response => {
        especialidades.value = response
      }, error => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Especialidades]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
    }

    //* Carga catálogo de especialidades
    const loadDivisiones = () => {
      divisionesList().then(response => {
        divisiones.value = response
      }, error => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Divisiones]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
    }

    onMounted(
      () => {
        if (props.id) loadPlanData() //* If we have an id, so component will edit, get data
        else newPlanData() //* Will create a new item, so put empty data
        loadEspecialidades()
        loadDivisiones()
      },
    )

    const validationForm = () => {
      formPlan.value.validate().then(success => {
        if (success) saveChanges()
        else {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Formulario incompleto',
              text: 'Revise que todas las cajas de texto requeridas contenga los datos y cumplan con las reglas solicitadas',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          },
          { timeout: 10000 })
        }
      })
    }

    watch(nuevaespecialidad, () => {
      planEstudios.value.division = {
        id: null,
        nombre: null,
      }

      planEstudios.value.nombre_corto = null

      planEstudios.value.especialidad = {
        id: null,
        division: null,
        nivel: null,
        nombre_corto: null,
      }
    })

    return {
      loadPlanData,
      saveChanges,
      loader,
      seriacionSelected,
      planEstudios,
      isEmptyObject,
      especialidades,
      divisiones,
      nuevaespecialidad,

      required,
      formPlan,
      validationForm,
      userRole,
    }
  },
}
</script>
